/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumnbusiness3Inputs */

const en_aicostscolumnbusiness3 = /** @type {(inputs: Aicostscolumnbusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const de_aicostscolumnbusiness3 = /** @type {(inputs: Aicostscolumnbusiness3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Aicostscolumnbusiness3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumnbusiness3 = /** @type {((inputs?: Aicostscolumnbusiness3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumnbusiness3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumnbusiness3(inputs)
	return de_aicostscolumnbusiness3(inputs)
});
export { aicostscolumnbusiness3 as "aiCostsColumnBusiness" }